import { Box } from '@mui/system';
import { Divider, Typography } from '@mui/material';
import { PaymentLinkButton } from '../../PaymentLinkButton';
import { useGetAccountPlanDefinitions } from '../../../../hooks/query/useAccounts';
import { AccountRecruitingUsageType } from '../../../../consts/enums';

type PaymentLinksSectionProps = {
  accountId: string;
};

export const PaymentLinksSection = ({
  accountId,
}: PaymentLinksSectionProps): JSX.Element => {
  const {
    data: hiringManagerPlanDefinitions = [],
  } = useGetAccountPlanDefinitions({
    recruitingUsageType: AccountRecruitingUsageType.RecruiterForOwnCompany,
  });
  const { data: recruiterPlanDefinitions = [] } = useGetAccountPlanDefinitions({
    recruitingUsageType: AccountRecruitingUsageType.RecruitingForOtherCompanies,
  });

  return (
    <Box>
      <Typography variant="subtitle1">
        Hiring Manager Plans Payment Links:
      </Typography>

      <Box>
        {hiringManagerPlanDefinitions
          .filter(
            ({ isCreditsBased, isPaidPlan, isCustomPlan }) => isCreditsBased && isPaidPlan && !isCustomPlan,
          )
          .sort((a, b) => a.pricingPlan.localeCompare(b.pricingPlan))
          .map(({ id, displayName }) => (
            <PaymentLinkButton
              key={ id }
              text={ displayName }
              accountId={ accountId }
              planDefinitionId={ id }
            />
          ))}
      </Box>

      <Divider sx={ { marginBlock: '15px' } } />

      <Typography variant="subtitle1">
        Recruiter Plans Payment Links:
      </Typography>

      <Box>
        {recruiterPlanDefinitions
          .filter(
            ({ isCreditsBased, isPaidPlan, isCustomPlan }) => isCreditsBased && isPaidPlan && !isCustomPlan,
          )
          .sort((a, b) => a.pricingPlan.localeCompare(b.pricingPlan))
          .map(({ id, displayName }) => (
            <PaymentLinkButton
              key={ id }
              text={ displayName }
              accountId={ accountId }
              planDefinitionId={ id }
            />
          ))}
      </Box>
    </Box>
  );
};
